import { render, staticRenderFns } from "./GameSlide.vue?vue&type=template&id=2ee9f446&lang=pug"
import script from "./GameSlide.vue?vue&type=script&lang=js"
export * from "./GameSlide.vue?vue&type=script&lang=js"
import style0 from "./GameSlide.vue?vue&type=style&index=0&id=2ee9f446&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports